import { RightArrowIcon, Section3BannerL, Section3BannerM, Section3BannerS, Section3BannerXL } from "src/assets";
import { Button } from "src/ui/widgets";

import { useSection3 } from "./section3.hook";
import { Image } from "react-bootstrap";

export const Section3 = () => {
  const { isMobile, isTablet, isDesktop, isLargeDesktop, t, toInsertPage } =
    useSection3();

  return (
    <div className="position-relative bg-00686F mt-4 mt-sm-0">
   {isLargeDesktop && (
          <Image
            src={Section3BannerXL}
            alt="Section3BannerXL"
            width="100%"
            height="100%"
          />
        )}

        {isDesktop && !isLargeDesktop && (
          <Image
            src={Section3BannerL}
            alt="Section3BannerL"
            width="100%"
            height="100%"
          />
        )}

        {isTablet && !isDesktop && (
          <Image
            src={Section3BannerM}
            alt="Section3BannerM"
            width="100%"
            height="100%"
          />
        )}

        {isMobile && (
          <Image
            src={Section3BannerS}
            alt="Section3BannerS"
            width="100%"
            height="100%"
          />
        )}

      <div className="section3-align-item">
        <h2 className="white-space-pre section3-dynamic-size-title c-ffffff text-center">
          {t("landing.section_3_title")}
        </h2>
        <div className="mt-md-5 mt-3 d-flex align-items-center justify-content-center">
          <Button
            text={t("commons.buy_now_button")}
            iconRight={RightArrowIcon}
            iconSize={18}
            classes="primary"
            classesText="buy-now-button-text text-uppercase"
            onPress={toInsertPage}
          />
        </div>
      </div>
    </div>
  );
};
